<div class="h-screen w-screen">
    <mat-drawer-container>
        <!-- Drawer -->
        <mat-drawer
            class="w-128"
            [autoFocus]="false"
            [mode]="drawerMode"
            [opened]="drawerOpened"
            [position]="drawerPosition"
            [disableClose]="true"
            #drawer
        >
            <router-outlet name="sidebar"></router-outlet>
        </mat-drawer>

        <!-- Drawer content -->
        <mat-drawer-content class="flex w-full h-full">
            <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
     Otherwise, layout changes won't be registered and the view won't be updated! -->
            <router-outlet></router-outlet>
        </mat-drawer-content>
    </mat-drawer-container>
</div>
